import React, { FC } from 'react';
import styled from 'styled-components';

import { CARD_BREAKPOINT } from '../constants';

// Page

// Displays all contents of a page
// For a standard page, top-level children of this component include:
// Nav (first child)
// Footer (last child)
// Between Nav and Footer, a flexbox sibling might include the following top-level children:
// LoadingSpinner
// Card

interface PageProps {
  children: React.ReactNode;
}

// Styles -----------------------------------------------------------------------------------------
// Outer container centers children in a column
const Container = styled.div`
  min-height: 100%;
  display: flex;
  padding: 2.5rem 0 0;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  background-color: #f7f7f7;
  @media (max-width: ${CARD_BREAKPOINT}) {
    padding: 0;
  }
`;
Container.displayName = 'Container';

// Component --------------------------------------------------------------------------------------
export const Page: FC<PageProps> = ({ children }) => (
  <Container>{children}</Container>
);
